import { Box, Stack } from "@repo/ui/core";
import { motion } from "framer-motion";
import { SlideTitle } from "@components/SlideTitle";

const QUESTIONS = [
  "Software Factory workflow support",
  "Cloud Workstation personas & configurations",
  "Templates & Snapshots as PaaS",
  "Compliance gate roadmap (Treble, CTS, VTS)",
  "AAOS behavioral parity",
  "Arm architecture path",
  "Host OS build support (Linux, QNX)",
  "Pilot working model & next steps",
];

export function QuestionsAnsweredSlide() {
  const svgW = 900;
  const rowH = 44;
  const startY = 20;
  const dotX = 30;
  const questionX = 50;
  const svgH = startY + QUESTIONS.length * rowH + 20;

  return (
    <Box w="100%" maw={1400} px="xl">
      <Stack gap="md">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <SlideTitle
            title="Questions for Discussion"
            subtitle="Pre-submitted topics from your team"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          <svg
            viewBox={`0 0 ${svgW} ${svgH}`}
            width="100%"
            style={{ display: "block", maxHeight: "62vh" }}
            aria-label="List of pre-submitted questions for discussion"
          >
            {QUESTIONS.map((q, i) => {
              const y = startY + i * rowH;

              return (
                <motion.g
                  key={q}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.4 + i * 0.07, duration: 0.3 }}
                >
                  {i % 2 === 0 && (
                    <rect
                      x={10}
                      y={y - 2}
                      width={svgW - 20}
                      height={rowH}
                      rx={4}
                      fill="rgba(255,255,255,0.015)"
                    />
                  )}

                  <circle cx={dotX} cy={y + 18} r={3} fill="var(--customer-accent)" opacity={0.5} />

                  <text
                    x={questionX}
                    y={y + 22}
                    fontSize={13}
                    fill="rgba(255,255,255,0.85)"
                    fontWeight={500}
                    fontFamily="inherit"
                  >
                    {q}
                  </text>
                </motion.g>
              );
            })}
          </svg>
        </motion.div>
      </Stack>
    </Box>
  );
}
